import { MemberRoleZod } from "./MemberRole";
import { JoinStatusZod } from "./JoinStatus";
import { NotificationRangeZod } from "./NotificationRange";
import { z } from "zod";

export type GroupMember = z.infer<typeof GroupMemberSchema>;
export const GroupMemberSchema = z.object({
  accessId: z.string(),
  idAccount: z.number(),
  inviteUserIdAccount: z.number().nullable(),
  name: z.string(),
  icon: z.string(),
  qr: z.string(),
  role: MemberRoleZod,
  joinStatus: JoinStatusZod,
  signUpAt: z.string().nullable(),
  notificationRange: NotificationRangeZod,
});
